import { endOfToday, isAfter, isBefore, isSameDay, startOfDay } from 'date-fns'
import dayjs from 'dayjs'

// This function disables future times in a time picker if the selected date is today.
// It compares the selected date with the current date and if they are the same, it disables hours, minutes, and seconds that are greater than the current time.
export const disableFutureTimesToday = (date) => {
  const now = dayjs()

  const kk = dayjs(date, 'DD-MM-YYYY')

  const testForSameDay = isSameDay(kk.toDate(), now.toDate())

  if (!testForSameDay) {
    return {} // If it's not today, no need to disable any times
  }

  // If it is today, return the hours, minutes, and seconds that should be disabled
  return {
    disabledHours: () => Array.from({ length: 24 }, (_, i) => i).filter((hour) => hour > now.hour()),
    disabledMinutes: (selectedHour) =>
      selectedHour === now.hour()
        ? Array.from({ length: 60 }, (_, i) => i).filter((minute) => minute > now.minute())
        : [],
    disabledSeconds: (selectedHour, selectedMinute) =>
      selectedHour === now.hour() && selectedMinute === now.minute()
        ? Array.from({ length: 60 }, (_, i) => i).filter((second) => second > now.second())
        : [],
  }
}

// This function disables future dates in a date picker. If a createdAt date is provided, it also disables dates before the createdAt date.
export const disableFutureDates = (current, createdAt?: string | Date) => {
  if (!current) return false
  const date = current.toDate()
  if (isAfter(date, endOfToday())) return true
  if (createdAt && isBefore(date, startOfDay(new Date(createdAt)))) return true
  return false
}
